import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ComponentBase, CustomerInfo, SettingsService, DiscountModel } from 't4core';
import { Country, getCountries, getCountryByCode, getCountryByLanguageCode, getCountryDataByName } from '../../Models/Country';
import { NavigationService, NavigationResolver } from 'app-components';
import { AppIntegrationService, AppSettingsService, Coordinates } from 't4-app-integration';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.css'],
    animations: [
        trigger('flyInOut', [
            state('in', style({ transform: 'translateX(-100%)' })),
            transition('void => *', [
                style({ transform: 'translateX(100%)' }),
                animate(100)
            ]),
            transition('* => void', [
                animate(100, style({ transform: 'translateX(100%)' }))
            ])
        ])
    ],
    standalone: false
})
export class MenuComponent extends ComponentBase implements OnInit {
    @Input() public toggle: boolean;
    @Output() toggleMenu: EventEmitter<boolean> = new EventEmitter();
    public userLoggedIn: boolean = false;
    public userId: string = "";
    public customer: CustomerInfo;
    public userDetails: any;
    public version: string;
    public shellVersion: string;
    public menuOptions: { language: string; label: string; route: string }[] = [];

    public showCustomerInfo: boolean = false;
    public CustomerInfoList: CustomerInfoSettings[] = [];
    public selectedLanguage: string;
    public selectedCustomerInfo: CustomerInfoSettings;

    public userLocation: Coordinates = { Latitude: 0, Longitude: 0 };

    public country: Country;
    public countries: Country[] = getCountries();
    public language: string = this.appSettings.getLanguage();
    public hasActiveCampaign: boolean = false;
    public closeInviteOption: boolean = false;
    public discount: DiscountModel;
    public discountModel: DiscountModel;
    public appMenuTitle: string = '';
    public appMenuDescription: string = '';
    constructor(
      private navigationService: NavigationService,
      public appService: AppIntegrationService,
      public resolver: NavigationResolver,
      public appSettings: AppSettingsService,
      settingsService: SettingsService)
    {
      super();


      //Get the country by checking the closes station country property.
      //If we dont have an anticipiated country we check the default Brower language, and if that fails we fall back to swedish.
      var anticipatedUserCountry = this.appSettings.getAnticipatedUserCountry();
      if (anticipatedUserCountry != null) {
        this.country = getCountryDataByName(anticipatedUserCountry);
      }
      else {
        //GetBrowserLanguage have a fallback to en if none is found.
        var browserLanguage = AppSettingsService.GetBrowserLanguage();

        if (browserLanguage == "en") {
          this.country = getCountryByLanguageCode("sv");
        }
        else {
          this.country = getCountryByLanguageCode(browserLanguage);
        }
      }
    }

    public async ngOnInit() {
      this.loading = true;

      let details = await this.appSettings.getUser();
      this.customer = details.customer;
      this.userDetails = details.userDetails;
      this.userLoggedIn = details.userLoggedIn;
      this.menuOptions = this.appSettings.settings.menuOptions;
      this.version = this.appSettings.clientVersion;
      this.shellVersion = this.appSettings.appVersion == 'null' ? '' : this.appSettings.appVersion;

      //If we want to show the settings, then we create the object.
      this.showCustomerInfo = this.appSettings.settings.ShowCustomerSupportInfo;
      if (this.showCustomerInfo) {
        this.createCustomerInfoList();

        if (this.CustomerInfoList) {
          //if we have selected a support language before, we use that.
          if (this.appSettings.customerSupportLanguage != null)
            this.selectedCustomerInfo = this.CustomerInfoList.filter(x => x.language == this.appSettings.customerSupportLanguage)[0];
          //Otherwise we check if we have anticipated country we use that. And have a fallback to first object in the CustomerInfoList that should be SE.
          if (!this.selectedCustomerInfo)
            this.selectedCustomerInfo = this.CustomerInfoList.filter(x => x.language == this.country.language)[0] ?? this.CustomerInfoList[0];

          //Updates the flag to corresponde with the correct settting.
          if (this.selectedCustomerInfo)
            this.country = getCountryByLanguageCode(this.selectedCustomerInfo.language);

        }

      } 

      if (this.menuOptions)
        this.filterMenuOptions();

      try {
        this.discount = await this.appSettings.checkActiveInviteFriendsCampaign(this.country.fullName);
        if (this.discount) {
          this.hasActiveCampaign = this.discount.IsInviteFriendsCampaign;
          this.appMenuTitle = await this.Translate.translate(this.discount.AppMenuMessageTitle, '');
          this.appMenuDescription = await this.Translate.translate(this.discount.AppMenuMessageDescription, '');
        }
      } catch (ex) { }
      this.loading = false;
  }



  public filterMenuOptions() {
    var filtertMenuOptions = this.menuOptions.filter(x => x.language == this.language);
    //Fallback option - If we have no options, we add the swedish once as default.
    if (filtertMenuOptions.length < 1) {
      filtertMenuOptions = this.menuOptions.filter(x => x.language == "sv");
    }
    this.menuOptions = filtertMenuOptions;
  }


 public selectCountry(selectedCountry: Country) {
    this.country = selectedCountry;

    const countryToLanguageMap = {
      "se": "sv",
      "dk": "da",
      "de": "de",
      "no": "no",
      "en": "en",
      "is": "is",
      "fi": "fi"
    };

    // Find the language code corresponding to the selected country
   const languageCode = countryToLanguageMap[selectedCountry.shortName];

   //Saves the language selected.
   this.appSettings.customerSupportLanguage = languageCode;

    // Find the customer information based on the language code
   this.selectedCustomerInfo = this.CustomerInfoList.find(customerInfo => customerInfo.language === languageCode);
  }


  public  createCustomerInfoList() {
    this.CustomerInfoList = this.appSettings.settings.CustomerSupportInfo;
   
    //Gets all the Countries we have added in settings.
    const languages = this.CustomerInfoList.map(item => item.language);

    const languageToCountryMap = {
      "sv": "se",
      "da": "dk",
      "de": "de",
      "no": "no",
      "en": "en",
      "is": "is",
      "fi": "fi"
    };

    //Extract country codes corresponding to languages
    const countryCodes = languages.map(lang => languageToCountryMap[lang]);

    //Filters out the countries we dont have info for
    this.countries = this.countries.filter(country => countryCodes.includes(country.shortName));
  }


  public close() {
    this.toggleMenu.emit(true);
  }


  public async navigate(command: string) {
    if (command.startsWith("http")) {
      this.appService.openExternal(command);
    }
    else {
      this.toggleMenu.emit(true);
      if (await this.navigationService.isAuthenticationRequired(command) && !this.appSettings.userId) {
        this.navigationService.navigateToView("MyPage.SignIn");
      } else {
        this.navigationService.navigateToView(command);
      }
    }
  }


  public async signOut() {
    this.navigate("Start");
    this.appSettings.setUser(null);
    await this.UI.alert(
      "Intellitrailer.Menu.LoggedOut.Headline",
      "You have been signed out",
      "Intellitrailer.Menu.SignedOut.Message",
      "To sign in again, open the menu and tap the sign in button.");
  }

  public closeInvite() {
    this.closeInviteOption = true;
  }

  public async recieveClickOfferAction() {
    if (this.discount.NoCompetitionCampaign) {
      this.loading = true;
      if (this.discount.DiscountId) {
        this.discountModel = this.discount;
      }
      else {
        this.discountModel = await this.Api.get<DiscountModel>("/Campaign/GenerateCouponForInviteFriend", { isCustomerContext: false, userLoggedIn: this.userLoggedIn, country: this.country.fullName });
      }      
      var messageContent = await this.Translate.translate(this.discountModel.MessageContent, '');
      var messageHeader = await this.Translate.translate(this.discountModel.MessageContentHeader, '');
      this.loading = false;
      setTimeout(() => this.openOffer(messageHeader, messageContent), 0);
      //this.openOffer();
    }
    else {
      this.navigationService.navigateToView('Rental.InviteFriends', { campaignId: this.discount.DiscountId, country: this.country.fullName });
      this.toggleMenu.emit(true);
    }
  }

  openOffer(messageHeader: string, messageContent: string) {
    const APP_URLS = {
      use4free: {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.kanleiesandroid',
        ios: 'https://apps.apple.com/us/app/use4free/id1612470972',
        default: 'https://www.use4free.se/se/boka-online'
      },
      tysse_utleie: {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.androidTysseRental',
        ios: 'https://apps.apple.com/us/app/tysse/id6479396425',
        default: 'https://tysse.no/utleie/bestillonline'
      },
      "24rental_se": {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.android24rental',
        ios: 'https://apps.apple.com/us/app/24rental/id1561167227',
        default: 'https://www.24rental.se/boka-online'
      },
      brenderuprental: {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.bsgandroid',
        ios: 'https://apps.apple.com/us/app/brenderup-rental/id1572540717',
        default: 'https://www.brenderuprental.com/se/boka-slap'
      },
      "okq8_se": {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.okq8trailerandroid',
        ios: 'https://apps.apple.com/us/app/okq8-sl%C3%A4p/id1548277008',
        default: 'https://www.use4free.se/se/boka-online'//Need to get the proper url for okq8 slap 
      },
      maxbo: {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.bsgmaxbo',
        ios: 'https://apps.apple.com/us/app/maxbo-tilhenger/id1619084804',
        default: 'https://www.maxbo.no/tjenester/utleie-tilhenger/'
      }
    };

    let appUrl = '';
    var device = this.getMobileOperatingSystem();
    const themeKey = this.appSettings.settings.theme.toLowerCase().replace(/[^a-z0-9]/gi, '_');

    if (APP_URLS[themeKey]) {
      if (device == 'Android') {
        appUrl = APP_URLS[themeKey].android;
      } else if (device == 'iOS') {
        appUrl = APP_URLS[themeKey].ios;
      } else {
        appUrl = APP_URLS[themeKey].default;
      }
    } else {
      appUrl = 'https://www.use4free.se/se';
    }


    var message = messageContent;
    message = message.replace("**CODE**", this.discountModel.DiscountId);
    if (device == 'Android') {
      this.appService.shareOffer(message + appUrl);
    } else if (navigator.share) {
      navigator.share({
        title: '🚛 ' + messageHeader,
        text: message,
        url: appUrl
      }).then(() => {
        console.log('Thanks for sharing!');
      }).catch((error) => {
        console.error('Error sharing:', error);
      });
    } else {
      console.log('Sharing not supported');
    }
  }

  public getMobileOperatingSystem(): string {
    var userAgent = navigator.userAgent || navigator.vendor;

    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    var win: any = window;
    if (/iPad|iPhone|iPod/.test(userAgent) && !win.MSStream) {
      return "iOS";
    }

    return "unknown";
  }

}


export interface CustomerInfoSettings {
  language: string;
  email: string;
  phone: string;
}
